// extracted by mini-css-extract-plugin
export default {"callLinkWrap":"VoiceCallLink_callLinkWrap__SyddA"};